// extracted by mini-css-extract-plugin
export default {"tooltip":"BarChartTooltip_tooltip__Vw0GM","colorBlock":"BarChartTooltip_colorBlock__d7Ha8"};